import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Environment } from "../backend-interface/environment";
import { environment } from "src/environments/environment";
import { Backend } from "../backend-interface/backend";
import { lastValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NetworkService {

  private environment!: Environment;
  /** configuration of http request */
  private readonly options = {
    observe: "body" as const,
    responseType: 'json' as const,
  }

  constructor(private readonly http: HttpClient) {
    Backend.networkService = this;
  }

  /**
   * Set json file env according to the launch environment (develop , eacc or prod)
   * 
   */
  public async loadEnvironment(): Promise<void> {
    this.environment = environment
  }

  /**
    * Get the current environment
    */
  public getEnvironment(): Environment {
    if (!this.environment) {
      throw new Error("Environment not loaded");
    }
    return this.environment;
  }

  /**
    * Abstract GET
  */
  public async get<T>(service: string, api: keyof Environment): Promise<T> {
    const url = `${this.environment[api]}/${service}`;
    return await lastValueFrom(this.http.get<T>(url, this.options));
  }

  /**
    *  Abstract PUT
  */
  public async put<T>(service: string, body: any, api: keyof Environment): Promise<T> {
    const url = `${this.environment[api]}/${service}`;
    return await lastValueFrom(this.http.put<T>(url, body, this.options));
  }

  /**
    *  Abstract POST
  */
  public async post<T>(service: string, body: any, api: keyof Environment): Promise<T> {
    const url = `${this.environment[api]}/${service}`;
    return await lastValueFrom(this.http.post<T>(url, body, this.options));
  }

  /**
    *  Abstract DELETE
  */
  public async delete<T>(service: string, api: keyof Environment): Promise<T> {
    const url = `${this.environment[api]}/${service}`;
    return await lastValueFrom(this.http.delete<T>(url, this.options));
  }

  /**
    *  Abstract PATCH
  */
  public async patch<T>(service: string, body: any, api: keyof Environment): Promise<T> {
    const url = `${this.environment[api]}/${service}`;
    return await lastValueFrom(this.http.patch<T>(url, body, this.options));  
  }
}
